
import React, { useEffect, useState } from 'react';
import Select from 'react-select';
import ApiService from '../../services/apiService';
import ApiService2 from '../../../POS/services/apiService';
import { toast } from 'react-toastify';
import userManagement from '../../../POS/services/userManagement';
import { Navigate, useLocation, useNavigate } from 'react-router-dom';
import moment from 'moment';
import ItemlistGrid from './itemsGrid';
import IssueAuthorization from './issueAuthorization';
import IssueMessageGrid from './IssueMessage';
import { ClipLoader } from 'react-spinners';
import { useSelector } from 'react-redux';
import { getCompany, getName, getUserId, getUserName } from '../../../Redux/selecters';
import { RiRefreshLine } from "react-icons/ri";
import { FaAngleLeft } from "react-icons/fa6";
import { FaSave } from "react-icons/fa";
import Modal from 'react-bootstrap/Modal';

const EditIssue = () => {
    const REPORT_URL = process.env.REACT_APP_REPORTS_URL

    const [activeTab, setActiveTab] = useState(0);
    const [gridVisibility, setGridVisibility] = useState([true, false, false]);
    const apiService2 = new ApiService2()
    const apiService = new ApiService();
    const [messageData, setMessageData] = useState([]);
    const [SelectedCurrency, setSelectedCurency] = useState([]);
    const [currency, setCurrency] = useState([]);
    const [department, setDepartment] = useState([]);
    const [Location, setLocation] = useState([]);
    const [authorizationData, setAuthorizationData] = useState([]);
    const [requisitionData, setRequisitionData] = useState([]);
    const [requisitionList, setRequisitionList] = useState([]);
    const [requisitionDrop, setRequisitionDrop] = useState([]);
    const [usersDetails, setUser] = useState([]);
    const [StockType, setStockType] = useState();
    const [loader, setLoader] = useState(false);
    const [itemNo, setItemNo] = useState();
    let navigate = useNavigate();
    const location = useLocation();
    const itemData = location.state;
    const userId = useSelector(getUserId);
    const userName = useSelector(getUserName);
    const Company = useSelector(getCompany);
    const [POTab, setPOTab] = useState(true);
    const [attachmentModal, setAttachmentModal] = useState(false);
    const [attachmentList, setAttachmentList] = useState([{ id: Date.now(), fileName: '', remarks: '' }]);
    const handleClose = () => setAttachmentModal(false);
    const handleOpen = () => setAttachmentModal(true);
    const [previewModal, setPreviewModal] = useState(false);
    const [previewImage, setPreviewImage] = useState(null);

    const todayDate = new Date().toISOString().substr(0, 10);
    const [formData, setFormData] = useState({
        requisitionNo: "",
        itemType: "",
        quatotionNo: "",
        remarks: "",
        requestor: "",
        date: todayDate,
        requisitionDate: todayDate,
        deliveryDate: todayDate,
        currencyCode: "",
        exchangeRate: "",
        department: [],
        costCenter1: "",
        costCenter2: "",
        costCenter3: "",
        costCenter4: "",
        description: "",
        fromLocation: [],
        toLocation: [],
        contactPerson: "",
        contatNo: "",
        taskCode: "",
        subcatname: "",
        refNo: "",
        StockType: ""
    });

    useEffect(() => {
        getCurrency()
        getLocation()
        getDepartment()
        getApprovalUser()
    }, [])
    useEffect(() => {
        const item = location.state;
        setFormData({
            recordId: item?.recordId,
            requisitionDate: item?.requisitionDate || todayDate,
            deliveryDate: item?.deliveryDate ? item.deliveryDate.substr(0, 10) : todayDate,
            requisitionNo: { label: item?.requisitionNo, value: item?.requisitionNo },
            itemType: item?.type,
            quatotionNo: item?.contractNo,
            remarks: item?.remarks,
            requestor: item?.requestor,
            currencyCode: item?.currencyCode,
            costCenter2: item?.costCenter2,
            costCenter3: item?.costCenter3,
            costCenter4: item?.costCenter4,
            deliveryPoint: item?.deliveryPoint,
            contactPerson: item?.contactPerson,
            contatNo: item?.contatNo,
            taskCode: item?.projectCode,
            location: item?.location,
        });
        const selectedDepartment = department?.find(dep => dep.description === item?.department)
        if (selectedDepartment) {
            setFormData(prevState => ({
                ...prevState,
                department: { label: selectedDepartment.description, value: selectedDepartment }
            }));
        }
        const selectedLocation = Location?.find(dep => dep.location === item?.costCenter1)
        if (selectedLocation) {
            setFormData(prevState => ({
                ...prevState,
                costCenter1: { label: selectedLocation.location, value: selectedLocation }
            }));
        }
    }, [location?.state, department, Location]);
    const getApprovalUser = async () => {
        try {
            if (location.state) {
                const params = new URLSearchParams();
                params.append('DocNo', itemData?.issueNo);
                params.append('DocumentType', "Issue");
                const response = await apiService.getApiParamater('GET_DOC_STATUS_EDIT', `?${params.toString()}`);
                setUser(response.data.result);
            } else {
                const approvalList = await apiService.get('GET_APPROVAL_USER');
                const approvals = approvalList?.data.result?.filter(dep => dep.active === 1)
                const approvalslist = approvals?.filter(dep => dep.docType === "Issue")
                setUser(approvalslist)
            }
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };
    let param = `?isActive=true`
    const getCurrency = async () => {
        const apiService = new ApiService()
        let res = await apiService.getApiParamater('GET_CURRENCY_MASTER', param)
        setCurrency(res?.data?.result)
        const filteredDenominations = res?.data?.result?.find(currency => currency?.isDefault === true);
        if (filteredDenominations) {
            setSelectedCurency({ label: filteredDenominations.code, value: filteredDenominations });
        }
        setFormData({ ...formData, exchangeRate: filteredDenominations?.conversionRate });
    }
    const getLocation = async () => {
        let res = await apiService.get('GET_WAREHOUSE_MASTER')
        const stockType = await apiService.getApiParamater("GET_STOCK_TYPE", param);
        setStockType(stockType?.data?.result);
        let reqParam = `?ReqType=${"Store Requisition"}&Status=1&ReqType2=${'Store Request'}`
        const ReqRes = await apiService.getApiParamater('GET_PR', reqParam);
        let dropParam = `?Mode=NEW`
        const dropList = await apiService.getApiParamater('GET_ISSUE_LIST_RECI', dropParam)

        setRequisitionDrop(dropList?.data?.result)
        if (itemData) {
            setItemNo(itemData.issueNo);
        } else {
            let docParam = `?TypeOfDoc=STI&DocId=Issue`
            let DocId = await apiService.getApiParamater('GET_DOC_ID', docParam)
            setItemNo(DocId?.data.result[0].docId);
        }
        setRequisitionList(ReqRes.data.result)
        setLocation(res?.data?.result)
    }
    const getDepartment = async () => {
        let res = await apiService.getApiParamater('GET_DEPARTMENT_MASTER', param)
        setDepartment(res?.data?.result)
    }
    const handleTabClick = (tabIndex) => {
        setActiveTab(tabIndex);
        const newGridVisibility = gridVisibility.map((_, index) => index === tabIndex);
        setGridVisibility(newGridVisibility);
    };
    const handleMessage = (data) => {
        setMessageData(data);
        console.log(data, 'reqData')

    };
    const handleRequisitionData = (data) => {
        setRequisitionData(data);
        console.log(data, 'reqData')
    };
    const handleAuthorization = (data) => {
        setAuthorizationData(data);
        console.log(data, 'reqData')
    };
    const staticOptions = [];
    const CreatePR = async () => {
        setLoader(true)
        if (!formData.fromLocation) {
            toast.warning("Enter from location");
            setLoader(false)
            return;
        }
        if (requisitionData.length === 0) {
            toast.warning("Please add items");
            setLoader(false)
            return;
        }
        if (!formData.toLocation) {
            toast.warning("Enter To location");
            setLoader(false)
            return;
        }
        for (const item of requisitionData) {
            if (!item.qty) {
                toast.warning(`Please enter ${item.itemDescription} quantity`);
                setLoader(false);
                return;
            }
        }
        if (formData?.toLocation?.label === formData?.fromLocation?.label) {
            toast.warning(`Location must be different `);
            setLoader(false);
            return;
        }

        const hasBaseQty = requisitionData.some(item => item.issueQty > 0);
        if (!hasBaseQty) {
            toast.warning("At least one item must have a base quantity greater than zero.");
            setLoader(false);
            return;
        }
        for (const item of requisitionData) {
            if (!item.itemDescription) {
                toast.warning(`Please Select Item`);
                setLoader(false);
                return;
            } else if (item.issueQty > item.stock) {
                toast.warning(`${item.itemDescription}  - Issue quantity must be less than or equal to the available stock `);
                setLoader(false);
                return;
            }
        }
        const missingGRNAcc = requisitionData?.find(item => !item.cgsAcc);
        if (missingGRNAcc) {
            toast.warning(`Please Add CGS Accounts for ${missingGRNAcc?.itemDescription}`);
            setLoader(false)
            return;
        }
        const totalAmount = requisitionData.reduce((sum, row) => sum + (row?.qty * row.unitPrice || 0), 0);
        try {
            const issueDetailDtos = requisitionData?.map(item => ({
                srno: parseInt(item.srno),
                itemCode: item?.ItemNo,
                itemDescription: item.itemDescription,
                uom: item.uom,
                qty: parseFloat(item.issueQty),
                specification: item.specification,
                convValue: parseFloat(item?.convRate),
                unitPrice: parseFloat(item.unitPrice),
                amount: parseFloat(item.issueQty * item.unitPrice),
                baseAmount: parseFloat(item.issueQty * item.unitPrice),
                issueNo: itemNo,
                rsrno: parseInt(item.srno),
                itemDetailId: 0,
                stockSrNo: 0,
                received: 0,
                cgsAccountCode: item?.cgsAcc,
                cgsAccountName: item?.cgsAccName,
                prodDate: moment(formData.date).format(),
                expDate: moment(item.expDate).format(),
            }));
            const currentDatetimeUTC = new Date().toISOString();
            const userData = {
                issueNo: itemNo,
                requisitionNo: formData.requisitionNo.label,
                issueDate: moment(formData.date).format(),
                description: formData?.description,
                // department: formData?.department?.label,
                department: "IT",
                issuedBy: userName,
                modifiedBy: userName,
                warehouse: formData?.fromLocation?.label,
                issueRefNo: formData?.refNo,
                currencyCode: SelectedCurrency.label,
                exchangeRate: SelectedCurrency?.value.conversionRate,
                amount: parseFloat(totalAmount),
                baseAmount: parseFloat(totalAmount),
                status: 0,
                approvalDate: currentDatetimeUTC,
                remarks: formData.remarks,
                costCenter1: formData.costCenter1?.label,
                costCenter2: formData.costCenter2?.label,
                costCenter3: formData.costCenter3?.label,
                costCenter4: formData.costCenter4?.label,
                divisionCode: formData.toLocation.label,
                divisionName: formData.toLocation.label,
                issueType: "GENERAL",
                issueDetailDtos: issueDetailDtos,
            };

            const response = await apiService.post("CREATE_ITEM_ISSUE", userData);
            if (response?.data?.statusCode === 201) {
                const docNumber = response?.data?.result?.issueNo
                const docBody = {
                    docId: "Issue",
                    typeOfDoc: "STI",
                };
                const docRes = await apiService.put("UPDATE_DOC_ID", docBody);
                const userData2 = {
                    docType: "issue",
                    docId: docNumber ? docNumber.toString() : itemNo,
                    department: "IT",
                    company: Company?.selectedCompany?.companyNo,
                    userCode: userId,
                    userName: userName,
                };
                const response2 = await apiService.post("CREATE_DOC_AUTHORIZATION", userData2);
                const paramsGet = new URLSearchParams();
                paramsGet.append('docType', "Issue");
                paramsGet.append('docId', itemNo);
                paramsGet.append('srno', 1);
                const response3 = await apiService.getApiParamater('GET_DOC_APPROVAL_USER', `?${paramsGet.toString()}`);
                if (response3?.data?.result.length > 0) {
                    const toEmails = response3?.data?.result?.map(user => user.userEmail);
                    const emailbody = {
                        toEmails: toEmails,
                        subject: "Issue Item",
                        body: "",
                        docNo: itemNo,
                        srNo: 1,
                        docType: "Issue"
                    };
                    const emailres = await apiService.post("DOC_APPROVAL_EMAIL_POST", emailbody);
                }

                // const token = localStorage.getItem("Token");
                // const DB = localStorage.getItem("DataBase")
                // if (!token) {
                //     alert("Auth token is missing! Unable to proceed.");
                //     return;
                // }
                // const popupWidth = 1000;
                // const popupHeight = 600;
                // const popupLeft = (window.screen.width - popupWidth) / 2;
                // const popupTop = (window.screen.height - popupHeight) / 2;
                // const popup = window.open(
                //     "",
                //     "ReportPopup",
                //     `width=${popupWidth},height=${popupHeight},left=${popupLeft},top=${popupTop},resizable=yes,scrollbars=yes`
                // );

                // if (popup) {
                //     const form = document.createElement("form");
                //     form.method = "POST";
                //     form.action =
                //         REPORT_URL;
                //     form.target = "ReportPopup";

                //     const inputs = [
                //         { name: "authToken", value: token },
                //         { name: "_db", value: DB },
                //         { name: "reportName", value: "Issue" },
                //         { name: "voucherNo", value: itemNo },
                //     ];

                //     inputs.forEach(({ name, value }) => {
                //         const input = document.createElement("input");
                //         input.type = "hidden";
                //         input.name = name;
                //         input.value = value;
                //         form.appendChild(input);
                //     });

                //     document.body.appendChild(form);
                //     form.submit();
                //     document.body.removeChild(form);
                // }
                toast.success(`${itemNo} Created successfully`);
                setLoader(false)
                setFormData({
                    itemType: "",
                    quatotionNo: "",
                    remarks: "",
                    requestor: "",
                    requisitionDate: "",
                    deliveryDate: "",
                    currencyCode: "",
                    department: "",
                    costCenter1: "",
                    costCenter2: "",
                    costCenter3: "",
                    costCenter4: "",
                    deliveryPoint: "",
                    location: "",
                    contactPerson: "",
                    contatNo: "",
                    taskCode: "",
                });
                navigate("/Inventory/IssueItems/List")
            } else {
                toast.warning(response?.data.message)
            }
            setLoader(false)
        } catch (error) {
            setLoader(false)
            console.error("Error Creating PR:", error);
        }
    };
    const UpdatePR = async () => {
        setLoader(true)
        if (!formData.fromLocation) {
            toast.warning("Enter from location");
            setLoader(false)
            return;
        }
        if (!formData.toLocation) {
            toast.warning("Enter To location");
            setLoader(false)
            return;
        }
        if (requisitionData.length === 0) {
            toast.warning("Please add items");
            setLoader(false)
            return;
        }
        for (const item of requisitionData) {
            if (!item.qty) {
                toast.warning(`Please enter ${item.itemDescription} quantity`);
                setLoader(false);
                return;
            }
        }
        const totalAmount = requisitionData.reduce((sum, row) => sum + (row?.amount), 0);
        try {
            const issueDetailDtos = requisitionData?.map(item => ({
                srno: parseInt(item.srno),
                itemCode: item?.ItemNo,
                itemDescription: item.itemDescription,
                uom: item.uom,
                qty: parseInt(item.issueQty),
                specification: item.specification,
                convValue: parseInt(item?.baseQty),
                unitPrice: parseInt(item.baseAmount),
                amount: parseInt(item.amount),
                baseAmount: parseInt(item.amount),
                issueNo: itemNo,
                rsrno: parseInt(item.srno),
                itemDetailId: 0,
                received: 0,
                stockSrNo: 0,
                cgsAccountCode: "string",
                cgsAccountName: "string",
            }));
            const currentDatetimeUTC = new Date().toISOString();
            const userData = {
                issueNo: itemNo,
                requisitionNo: formData.requisitionNo.label,
                issueDate: moment(formData.date).format(),
                description: formData.description,
                department: formData.department.label,
                issuedBy: userName,
                warehouse: formData.fromLocation.label,
                issueRefNo: formData.refNo,
                currencyCode: formData.currencyCode,
                exchangeRate: 0,
                amount: totalAmount,
                baseAmount: 0,
                status: 0,
                approvalDate: currentDatetimeUTC,
                remarks: formData.remarks,
                costCenter1: " ",
                costCenter2: " ",
                costCenter3: " ",
                costCenter4: " ",
                divisionCode: formData.toLocation.label,
                divisionName: formData.toLocation.label,
                issueType: "general",
                issueDetailDtos: issueDetailDtos,
            };
            const response = await apiService.post("UPDATE_ITEM_ISSUE", userData);
            if (response?.data?.statusCode === 201) {
                const userData2 = {
                    docType: "Issue",
                    docId: itemNo,
                    status: 0,
                    remarks: formData?.remarks,
                };
                const response2 = await apiService.put("UPDATE_DOC_AUTHORIZATION_STATUS", userData2);
                const paramsGet = new URLSearchParams();
                paramsGet.append('docType', "Issue");
                paramsGet.append('docId', itemNo);
                paramsGet.append('srno', 1);
                const response3 = await apiService.getApiParamater('GET_DOC_APPROVAL_USER', `?${paramsGet.toString()}`);
                if (response3?.data?.result.length > 0) {
                    const toEmails = response3?.data?.result?.map(user => user.userEmail);
                    const emailbody = {
                        toEmails: toEmails,
                        subject: "Issue Item",
                        body: "",
                        docNo: itemNo,
                        srNo: 1,
                        docType: "Issue"
                    };
                    const emailres = await apiService.post("DOC_APPROVAL_EMAIL_POST", emailbody);
                }
                toast.success(`${itemNo} Updated successfully`);
                setLoader(false)
                navigate("/Inventory/IssueItems/List")
            }
            setLoader(false)
        } catch (error) {
            setLoader(false)
            console.error("Error Creating PR:", error);
        }
    };
    const handleInputChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };
    const handlecurChange = (selectedOption) => {
        setFormData({ ...formData, currencyCode: selectedOption?.value?.code });
    };
    const handleReqChange = (selectedOption) => {

        const selectedRequisition = requisitionList?.find(dep => dep?.requisitionNo === selectedOption.label)
        const utcDate = new Date(selectedRequisition?.requisitionDate);
        const localDate = new Date(utcDate.getTime() - utcDate.getTimezoneOffset() * 60000).toISOString().split('T')[0];
        const selectedLocation = Location?.find(dep => dep?.description === selectedRequisition?.approvalUser)
        setFormData({
            ...formData,
            requisitionNo: selectedOption,
            requisitionDate: localDate,
            toLocation: { label: selectedLocation?.description, value: selectedLocation },
            costCenter1: { label: selectedRequisition?.costCenter1, value: selectedRequisition?.costCenter1 },
            costCenter2: { label: selectedRequisition?.costCenter2, value: selectedRequisition?.costCenter2 },
            costCenter3: { label: selectedRequisition?.costCenter3, value: selectedRequisition?.costCenter3 },
            costCenter4: { label: selectedRequisition?.costCenter4, value: selectedRequisition?.costCenter4 },
        });
    };
    const handlelocFromChange = (selectedOption) => {
        if (selectedOption?.label === formData?.toLocation?.label) {
            toast.warning("location Must be different from To Location")
            return
        } else {
            setFormData({ ...formData, fromLocation: selectedOption });
        }
    };
    const handlelocToChange = (selectedOption) => {
        if (selectedOption?.label === formData?.fromLocation?.label) {
            toast.warning("location Must be different from  From-Location")
            return
        } else {
            setFormData({ ...formData, toLocation: selectedOption });
        }
    };
    const handleDepToChange = (selectedOption) => {
        setFormData({ ...formData, department: selectedOption });
    };
    const handleStockChange = (selectedOption) => {
        setFormData({ ...formData, StockType: selectedOption });
    }
    const handleBackClick = () => {
        window.history.back();
    };
    const handleFileSelect = (event, id) => {
        const file = event.target.files[0];
        if (file) {
            setAttachmentList((prevList) => [
                ...prevList.map((attachment) =>
                    attachment.id === id ? { ...attachment, fileName: file.name, file: file } : attachment
                ),
                { id: Date.now(), fileName: '', remarks: '' },
            ]);
        }
    };
    const handleView = (file) => {
        if (file && file instanceof File) {
            setPreviewImage(URL.createObjectURL(file));
            setPreviewModal(true);
        } else {
            console.error("No valid file to preview");
        }
    };
    const handleDelete = (id) => {
        const updatedList = attachmentList.filter((attachment) => attachment.id !== id);
        setAttachmentList(updatedList);
    };
    return (
        <div className='px-4 pb-5'>
            <div className='d-flex justify-content-between pt-3'>
                <h5 className='col mainInvHead'>Issue Items</h5>
                <div className='d-flex gap-3'>
                    {itemData?.eye === true ? " " :
                        <>
                            {location.state ? (
                                <>{loader === true ?
                                    <button className='mainbtn ' type="submit"><ClipLoader color="#ffffff" size={25} /></button> :
                                    <button className='mainbtn ' onClick={UpdatePR} type="submit">
                                        <FaSave className='center mt-1 mx-2' /><div>Update</div>
                                    </button>
                                }
                                </>
                            ) : (
                                <>{loader === true ?
                                    <button className='mainbtn ' type="submit"><ClipLoader color="#ffffff" size={25} /></button> :
                                    <button className='mainbtn ' onClick={CreatePR} type="submit">
                                        <FaSave className='center mt-1 mx-2' /><div>Save</div>
                                    </button>
                                }
                                </>
                            )}</>
                    }
                    {itemData?.eye === true ? " " : <button className='mainbtnRed' ><RiRefreshLine className='center mt-1 mx-2' /><div>Reset</div></button>}
                    <button onClick={handleBackClick} className='mainbtn'><FaAngleLeft className='center mt-1 mx-2' /><div>Back</div></button>
                </div>
            </div>
            <div className="cost-center-section">
                <div className="d-flex mt-3 cursor-pointer slide-header"
                    onClick={() => setPOTab(!POTab)}>
                    <div className='h6 pt-1'>Issue Details</div>
                </div>
                <div className={`slide-content ${POTab ? 'open' : 'closed'}`}>
                    <div className={`border-box2 p-3 ${POTab ? 'slide-in' : 'slide-out'}`}>
                        <div className="form-group row pb-3">
                            <div className="d-flex justify-content-between col">
                                <label htmlFor="itemNo" className="form-label  pt-2 start">Issue Note No</label>
                                <input
                                    className="form-Input w-70"
                                    disabled
                                    value={itemNo}
                                    name="itemNo"
                                />
                            </div>
                            <div className="d-flex justify-content-between col">
                                <label htmlFor="inventoryAccountCode" className="form-label  pt-2 start">Currency</label>
                                {itemData?.eye === true ?
                                    <Select
                                        className="w-70 p-0"
                                        theme={(theme) => ({
                                            ...theme,
                                            borderRadius: 5,
                                            padding: 9
                                        })}
                                        menuPortalTarget={document.body}
                                        styles={{
                                            menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                            option: (provided, state) => ({
                                                ...provided,
                                                backgroundColor: state.isFocused ? '#F5F5F5 ' : null,
                                                color: state.isFocused ? '#000 ' : '#000',
                                                ':hover': {
                                                    backgroundColor: '#F5F5F5',
                                                    color: '#000 ',
                                                },
                                            }),
                                        }} isDisabled value={SelectedCurrency} /> :
                                    <Select
                                        className="w-70 p-0"
                                        theme={(theme) => ({
                                            ...theme,
                                            borderRadius: 5,
                                            padding: 9
                                        })}
                                        menuPortalTarget={document.body}
                                        styles={{
                                            menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                            option: (provided, state) => ({
                                                ...provided,
                                                backgroundColor: state.isFocused ? '#F5F5F5 ' : null,
                                                color: state.isFocused ? '#000 ' : '#000',
                                                ':hover': {
                                                    backgroundColor: '#F5F5F5',
                                                    color: '#000 ',
                                                },
                                            }),
                                        }}
                                        isSearchable={false}
                                        value={SelectedCurrency}
                                        onChange={(e) => handlecurChange(e)}
                                    />
                                }
                            </div>
                            <div className="d-flex justify-content-between col">
                                <label htmlFor="exchangeRate" className="form-label  pt-2 start">Exchange Rate</label>
                                {itemData?.eye === true ?
                                    <input disabled value={formData.exchangeRate} className="form-Input w-70" /> :
                                    <input
                                        type="number"
                                        className="form-Input w-70"
                                        disabled
                                        onWheel={(e) => e.target.blur()}
                                        id="exchangeRate"
                                        value={formData.exchangeRate}
                                        onChange={handleInputChange}
                                        name="exchangeRate"
                                    />
                                }
                            </div>
                        </div>
                        {/* Dropdowns for other fields */}
                        <div className="form-group row  pb-3">
                            <div className="d-flex justify-content-between col">
                                <label htmlFor="subcatname" className="form-label  pt-2 start">Requisition No</label>
                                {itemData?.eye === true ?
                                    <input disabled
                                        className="form-Input w-70"
                                        value={formData.requisitionNo}
                                    /> :
                                    <Select
                                        className="w-70 p-0"
                                        theme={(theme) => ({
                                            ...theme,
                                            borderRadius: 5,
                                            padding: 9
                                        })}
                                        menuPortalTarget={document.body}
                                        styles={{
                                            menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                            option: (provided, state) => ({
                                                ...provided,
                                                backgroundColor: state.isFocused ? '#F5F5F5 ' : null,
                                                color: state.isFocused ? '#000 ' : '#000',
                                                ':hover': {
                                                    backgroundColor: '#F5F5F5',
                                                    color: '#000 ',
                                                },
                                            }),
                                        }}
                                        value={formData?.requisitionNo}
                                        onChange={(selectedOption) => handleReqChange(selectedOption)}
                                        options={requisitionDrop?.map((req) => ({ value: req?.requisitionNo, label: req?.requisitionNo }))}
                                    />
                                }
                            </div>
                            <div className="d-flex justify-content-between col">
                                <label htmlFor="department" className="form-label  pt-2 start">Department</label>
                                {itemData?.eye === true ?
                                    <input disabled
                                        className="form-Input w-70"
                                        value={formData.department}
                                    /> :
                                    <Select
                                        className="w-70 p-0"
                                        theme={(theme) => ({
                                            ...theme,
                                            borderRadius: 5,
                                            padding: 9
                                        })}
                                        menuPortalTarget={document.body}
                                        styles={{
                                            menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                            option: (provided, state) => ({
                                                ...provided,
                                                backgroundColor: state.isFocused ? '#F5F5F5 ' : null,
                                                color: state.isFocused ? '#000 ' : '#000',
                                                ':hover': {
                                                    backgroundColor: '#F5F5F5',
                                                    color: '#000 ',
                                                },
                                            }),
                                        }} value={formData.department}
                                        options={department?.map((dep) => ({ value: dep, label: dep?.description }))}
                                        onChange={(selectedOption) => handleDepToChange(selectedOption)}
                                    />
                                }
                            </div>
                            <div className="d-flex justify-content-between col">
                                <label htmlFor="inventoryAccountCode" className="form-label  pt-2 start">Property</label>
                                <Select
                                    value={formData.costCenter1}
                                    className="w-70 p-0"
                                    theme={(theme) => ({
                                        ...theme,
                                        borderRadius: 5,
                                        padding: 9
                                    })}
                                    menuPortalTarget={document.body}
                                    styles={{
                                        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                        option: (provided, state) => ({
                                            ...provided,
                                            backgroundColor: state.isFocused ? '#F5F5F5 ' : null,
                                            color: state.isFocused ? '#000 ' : '#000',
                                            ':hover': {
                                                backgroundColor: '#F5F5F5',
                                                color: '#000 ',
                                            },
                                        }),
                                    }} isDisabled />
                            </div>
                        </div>
                        <div className="form-group row pb-3">
                            <div className="d-flex justify-content-between col">
                                <label htmlFor="catcode" className="form-label  pt-2 start">Date </label>
                                {itemData?.eye === true ?
                                    <input
                                        className='form-Input w-70'
                                        type='date' disabled
                                        defaultValue={new Date().toISOString().substr(0, 10)}
                                    /> :
                                    <input
                                        className='form-Input w-70'
                                        type='date'
                                        value={formData.date}
                                        defaultValue={new Date().toISOString().substr(0, 10)}
                                        name="date"
                                        onChange={handleInputChange}
                                    />
                                }
                            </div>
                            <div className="d-flex justify-content-between col">
                                <label htmlFor="description" className="form-label  pt-2 start">Description</label>
                                {itemData?.eye === true ?
                                    <input disabled value={formData.location} className="form-Input w-70" /> :
                                    <input
                                        type="text"
                                        className="form-Input w-70"
                                        id="description"
                                        value={formData.description}
                                        onChange={handleInputChange}
                                        name="description"
                                    />
                                }
                            </div>
                            <div className="d-flex justify-content-between col">
                                <label htmlFor="subcatname" className="form-label  pt-2 start">Unit</label>
                                <Select
                                    value={formData.costCenter2}
                                    className="w-70 p-0"
                                    theme={(theme) => ({
                                        ...theme,
                                        borderRadius: 5,
                                        padding: 9
                                    })}
                                    menuPortalTarget={document.body}
                                    styles={{
                                        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                        option: (provided, state) => ({
                                            ...provided,
                                            backgroundColor: state.isFocused ? '#F5F5F5 ' : null,
                                            color: state.isFocused ? '#000 ' : '#000',
                                            ':hover': {
                                                backgroundColor: '#F5F5F5',
                                                color: '#000 ',
                                            },
                                        }),
                                    }} isDisabled />
                            </div>
                        </div>
                        <div className="form-group row pb-3">
                            <div className="d-flex justify-content-between col">
                                <label htmlFor="inventoryAccountCode" className="form-label  pt-2 start">From Location </label>
                                {itemData?.eye === true ?
                                    <Select
                                        className="w-70 p-0"
                                        theme={(theme) => ({
                                            ...theme,
                                            borderRadius: 5,
                                            padding: 9
                                        })}
                                        menuPortalTarget={document.body}
                                        styles={{
                                            menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                            option: (provided, state) => ({
                                                ...provided,
                                                backgroundColor: state.isFocused ? '#F5F5F5 ' : null,
                                                color: state.isFocused ? '#000 ' : '#000',
                                                ':hover': {
                                                    backgroundColor: '#F5F5F5',
                                                    color: '#000 ',
                                                },
                                            }),
                                        }} isDisabled /> :
                                    <Select
                                        className="w-70 p-0"
                                        theme={(theme) => ({
                                            ...theme,
                                            borderRadius: 5,
                                            padding: 9
                                        })}
                                        menuPortalTarget={document.body}
                                        styles={{
                                            menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                            option: (provided, state) => ({
                                                ...provided,
                                                backgroundColor: state.isFocused ? '#F5F5F5 ' : null,
                                                color: state.isFocused ? '#000 ' : '#000',
                                                ':hover': {
                                                    backgroundColor: '#F5F5F5',
                                                    color: '#000 ',
                                                },
                                            }),
                                        }}
                                        value={formData.fromLocation}
                                        options={Location?.map((loc) => ({ value: loc, label: loc?.description }))}
                                        onChange={(selectedOption) => handlelocFromChange(selectedOption)}
                                    />
                                }
                            </div>
                            <div className="d-flex justify-content-between col">
                                <label htmlFor="contactPerson" className="form-label  pt-2 start">Requester</label>
                                {itemData?.eye === true ?
                                    <input disabled value={formData.contactPerson} className="form-Input w-70" /> :
                                    <input
                                        type="text"
                                        className="form-Input w-70"
                                        id="contactPerson"
                                        value={formData.contactPerson}
                                        onChange={handleInputChange}
                                        name="contactPerson"
                                    />
                                }
                            </div>
                            <div className="d-flex justify-content-between col">
                                <label htmlFor="inventoryAccountCode" className="form-label  pt-2 start">Cost Center 3</label>
                                <Select
                                    value={formData.costCenter3}
                                    className="w-70 p-0"
                                    theme={(theme) => ({
                                        ...theme,
                                        borderRadius: 5,
                                        padding: 9
                                    })}
                                    menuPortalTarget={document.body}
                                    styles={{
                                        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                        option: (provided, state) => ({
                                            ...provided,
                                            backgroundColor: state.isFocused ? '#F5F5F5 ' : null,
                                            color: state.isFocused ? '#000 ' : '#000',
                                            ':hover': {
                                                backgroundColor: '#F5F5F5',
                                                color: '#000 ',
                                            },
                                        }),
                                    }} isDisabled />
                            </div>
                        </div>
                        <div className="form-group row pb-3">
                            <div className="d-flex justify-content-between col">
                                <label htmlFor="inventoryAccountCode" className="form-label  pt-2 start">To Location</label>
                                {itemData?.eye === true ?
                                    <Select
                                        className="w-70 p-0"
                                        theme={(theme) => ({
                                            ...theme,
                                            borderRadius: 5,
                                            padding: 9
                                        })}
                                        menuPortalTarget={document.body}
                                        styles={{
                                            menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                            option: (provided, state) => ({
                                                ...provided,
                                                backgroundColor: state.isFocused ? '#F5F5F5 ' : null,
                                                color: state.isFocused ? '#000 ' : '#000',
                                                ':hover': {
                                                    backgroundColor: '#F5F5F5',
                                                    color: '#000 ',
                                                },
                                            }),
                                        }} isDisabled /> :
                                    <Select
                                        className="w-70 p-0"
                                        theme={(theme) => ({
                                            ...theme,
                                            borderRadius: 5,
                                            padding: 9
                                        })}
                                        menuPortalTarget={document.body}
                                        styles={{
                                            menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                            option: (provided, state) => ({
                                                ...provided,
                                                backgroundColor: state.isFocused ? '#F5F5F5 ' : null,
                                                color: state.isFocused ? '#000 ' : '#000',
                                                ':hover': {
                                                    backgroundColor: '#F5F5F5',
                                                    color: '#000 ',
                                                },
                                            }),
                                        }}
                                        value={formData.toLocation}
                                        options={Location?.map((loc) => ({ value: loc, label: loc?.description }))}
                                        onChange={(selectedOption) => handlelocToChange(selectedOption)}
                                    />}
                            </div>
                            <div className="d-flex justify-content-between col">
                                <label htmlFor="inventoryAccountCode" className="form-label  pt-2 start">Issued By</label>
                                {itemData?.eye === true ?
                                    <Select
                                        className="w-70 p-0"
                                        theme={(theme) => ({
                                            ...theme,
                                            borderRadius: 5,
                                            padding: 9
                                        })}
                                        menuPortalTarget={document.body}
                                        styles={{
                                            menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                            option: (provided, state) => ({
                                                ...provided,
                                                backgroundColor: state.isFocused ? '#F5F5F5 ' : null,
                                                color: state.isFocused ? '#000 ' : '#000',
                                                ':hover': {
                                                    backgroundColor: '#F5F5F5',
                                                    color: '#000 ',
                                                },
                                            }),
                                        }} isDisabled /> :
                                    <Select
                                        className="w-70 p-0"
                                        theme={(theme) => ({
                                            ...theme,
                                            borderRadius: 5,
                                            padding: 9
                                        })}
                                        menuPortalTarget={document.body}
                                        styles={{
                                            menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                            option: (provided, state) => ({
                                                ...provided,
                                                backgroundColor: state.isFocused ? '#F5F5F5 ' : null,
                                                color: state.isFocused ? '#000 ' : '#000',
                                                ':hover': {
                                                    backgroundColor: '#F5F5F5',
                                                    color: '#000 ',
                                                },
                                            }),
                                        }}
                                        defaultValue={{ label: userName, value: userName }}
                                        onChange={(selectedOption) => handleInputChange('inventoryAccountCode', selectedOption)}
                                    />}
                            </div>
                            <div className="d-flex justify-content-between col">
                                <label htmlFor="inventoryAccountCode" className="form-label  pt-2 start">Cost Center 4</label>
                                <Select
                                    value={formData.costCenter4}
                                    className="w-70 p-0"
                                    theme={(theme) => ({
                                        ...theme,
                                        borderRadius: 5,
                                        padding: 9
                                    })}
                                    menuPortalTarget={document.body}
                                    styles={{
                                        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                        option: (provided, state) => ({
                                            ...provided,
                                            backgroundColor: state.isFocused ? '#F5F5F5 ' : null,
                                            color: state.isFocused ? '#000 ' : '#000',
                                            ':hover': {
                                                backgroundColor: '#F5F5F5',
                                                color: '#000 ',
                                            },
                                        }),
                                    }} isDisabled />
                            </div>
                        </div>
                        <div className="form-group row pb-3">
                            <div className="d-flex justify-content-between col">
                                <label htmlFor="refNo" className="form-label  pt-2 start">Ref No</label>
                                {itemData?.eye === true ?
                                    <input disabled className="form-Input w-70" value={formData.requestor} /> :
                                    <input
                                        type="text"
                                        className="form-Input w-70"
                                        id="refNo"
                                        value={formData.refNo}
                                        onChange={handleInputChange}
                                        name="refNo"

                                    />}
                            </div>
                            <div className="d-flex justify-content-between col">
                                <label htmlFor="catcode" className="form-label  pt-2 start">Request Date </label>
                                {itemData?.eye === true ?
                                    <input
                                        className='form-Input w-70' value={formData.requisitionDate}
                                        type='date' disabled
                                        defaultValue={new Date().toISOString().substr(0, 10)}
                                    /> :
                                    <input
                                        className='form-Input w-70'
                                        type='date' value={formData.requisitionDate}
                                        name="requisitionDate"
                                    // onChange={handleInputChange}
                                    />
                                }
                            </div>
                            <div className="d-flex justify-content-between col">
                                <label htmlFor="catcode" className="form-label  pt-2 start">Delivery Date </label>
                                {itemData?.eye === true ?
                                    <input
                                        className='form-Input w-70'
                                        type='date' disabled
                                        defaultValue={new Date().toISOString().substr(0, 10)}
                                    /> :
                                    <input
                                        className='form-Input w-70'
                                        type='date'
                                        defaultValue={new Date().toISOString().substr(0, 10)}
                                        name="requisitionDate"
                                        onChange={handleInputChange}
                                    />
                                }
                            </div>
                        </div>
                        <div className="form-group row ">
                            <div className="d-flex justify-content-between col-4">
                                <label htmlFor="inventoryAccountCode" className="form-label  pt-2 start">Stock Type</label>
                                {itemData?.eye === true ?
                                    <Select
                                        className="w-70 p-0"
                                        theme={(theme) => ({
                                            ...theme,
                                            borderRadius: 5,
                                            padding: 9
                                        })}
                                        menuPortalTarget={document.body}
                                        styles={{
                                            menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                            option: (provided, state) => ({
                                                ...provided,
                                                backgroundColor: state.isFocused ? '#F5F5F5 ' : null,
                                                color: state.isFocused ? '#000 ' : '#000',
                                                ':hover': {
                                                    backgroundColor: '#F5F5F5',
                                                    color: '#000 ',
                                                },
                                            }),
                                        }} isDisabled /> :
                                    <Select
                                        className="w-70 p-0"
                                        theme={(theme) => ({
                                            ...theme,
                                            borderRadius: 5,
                                            padding: 9
                                        })}
                                        menuPortalTarget={document.body}
                                        styles={{
                                            menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                            option: (provided, state) => ({
                                                ...provided,
                                                backgroundColor: state.isFocused ? '#F5F5F5 ' : null,
                                                color: state.isFocused ? '#000 ' : '#000',
                                                ':hover': {
                                                    backgroundColor: '#F5F5F5',
                                                    color: '#000 ',
                                                },
                                            }),
                                        }}
                                        value={formData.StockType}
                                        onChange={(selectedOption) => handleStockChange(selectedOption)}
                                        options={StockType?.map((Stock) => ({ value: Stock, label: Stock?.stockTypeName }))}
                                    />}
                            </div>
                            <div className="d-flex justify-content-between col-4">
                                <label htmlFor="remarks" className="form-label  pt-2 start">Remarks</label>
                                {itemData?.eye === true ?
                                    <input disabled
                                        className="form-Input w-70"
                                        value={formData.remarks}
                                    /> :
                                    <input
                                        name="remarks"
                                        type='text'
                                        className="form-Input w-70"
                                        id="remarks"
                                        value={formData.remarks}
                                        onChange={handleInputChange}
                                    />}
                            </div>
                            <div className='col-1 px-5 mx-3'></div>
                            <div className="col-2 brderbox center p-2" onClick={() => handleOpen()} >
                                {'Attachment'}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="slide-container p-2 mt-3">
                <div className="container-fluid">
                    <div className="nav nav-pills overslid d-flex gap-4">
                        {/* Nav tabs */}
                        <div
                            className={`dashitems sidebar-text center ${activeTab === 0 ? 'sideActive' : ''}`}
                            onClick={() => handleTabClick(0)}
                        >
                            Requisition
                        </div>
                        <div
                            className={`dashitems sidebar-text center  ${activeTab === 1 ? 'sideActive' : ''}`}
                            onClick={() => handleTabClick(1)}
                        >
                            Authorization
                        </div>
                        <div
                            className={`dashitems sidebar-text center  ${activeTab === 2 ? 'sideActive' : ''}`}
                            onClick={() => handleTabClick(2)}
                        >
                            Message
                        </div>
                    </div>
                </div>
            </div>
            <div className="grid-1 brderbox2 p-4 mb-3">
                {gridVisibility[0] && (
                    <ItemlistGrid onRequisitionData={handleRequisitionData} itemData={itemData} formData={formData}
                        fromlocation={formData?.fromLocation} currencyPrecision={SelectedCurrency?.value?.precision} />
                )}
                {gridVisibility[1] && (
                    <IssueAuthorization
                        handleAuthorization={handleAuthorization}
                        usersDetails={usersDetails}
                        setUser={setUser}
                        itemData={itemData}
                    />
                )}
                {gridVisibility[2] && (
                    <div className="grid-3 border">
                        <IssueMessageGrid handleMessage={handleMessage} />
                    </div>
                )}

            </div>
            <div>
                <Modal show={attachmentModal} size="lg" onHide={handleClose} >
                    <Modal.Header closeButton>
                        <Modal.Title>Attachments</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <div className="col d-flex justify-content-between">
                            <label htmlFor="docNp" className="form-label  pt-2 start">Document No</label>
                            <input disabled value={itemNo} className="form-Input w-70" />
                        </div>
                        <div className="pt-2">
                            <table>
                                <thead className="dynoTable">
                                    <tr>
                                        <th>File Name</th>
                                        <th>Remarks</th>
                                        <th>Upload</th>
                                        <th>View</th>
                                        <th>Delete</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {attachmentList?.map((attachment, index) => (
                                        <tr key={attachment.id}>
                                            <td className='m-0 p-0'><input className='p-0' type='text' disabled value={attachment.fileName} style={{ width: "320px" }} /></td>
                                            <td>
                                                <input type="text" value={attachment.remarks}
                                                    onChange={(e) => {
                                                        const updatedList = attachmentList?.map((item) =>
                                                            item.id === attachment.id ? { ...item, remarks: e.target.value } : item
                                                        );
                                                        setAttachmentList(updatedList);
                                                    }}
                                                    style={{ width: '345px' }}
                                                />
                                            </td>
                                            <td>
                                                <button className='mainbtn ' onClick={() => document.getElementById(`fileInput-${attachment.id}`).click()} type="submit"><div>Upload</div></button>
                                                <input
                                                    type="file" accept="image/*"
                                                    style={{ display: 'none' }}
                                                    onChange={(e) => handleFileSelect(e, attachment.id)}
                                                    id={`fileInput-${attachment.id}`}
                                                />
                                            </td>
                                            <td><button className='mainbtnRed ' onClick={() => handleView(attachment.file)} disabled={!attachment.fileName}>
                                                <div>View</div></button></td>
                                            <td>
                                                <button onClick={() => handleDelete(attachment.id)} disabled={!attachment.fileName} className='mainbtnSecondary'>
                                                    <div>Delete</div></button>
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    </Modal.Body>
                    <Modal.Footer>
                        <button className='mainbtn' onClick={handleClose} >Attach</button>
                    </Modal.Footer>
                </Modal>
                <Modal show={previewModal} size="lg" onHide={() => setPreviewModal(false)}
                    backdrop="static"
                    keyboard={false}>
                    <Modal.Header closeButton>
                        <Modal.Title>Image Preview</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        {previewImage && <img src={previewImage} alt={previewImage} style={{ width: '100%', objectFit: 'cover' }} />}
                    </Modal.Body>
                </Modal>
            </div>
        </div>
    )
}

export default EditIssue
